import { Grid, Typography } from "@sidelinesports/fan-design-system";
import type { ApiGameDetails } from "../../../../api/index.ts";
import { Dialog } from "../../../../components";
import { ScoreLegendTable } from "./ScoreLegendTable.tsx";

export type ScoreLegendProps = {
  game: ApiGameDetails;
  trigger: React.ReactNode;
};

export const ScoreLegend = ({ game, trigger }: ScoreLegendProps) => {
  return (
    <Dialog.Root>
      {trigger}
      <Dialog.Content size="md" name="ScoreLegendDialog">
        <Dialog.Header>Score Legend</Dialog.Header>
        <Dialog.Body>
          <Grid gap={16}>
            <Typography size="md">
              Listed below are events in which the players you select can score
              points from.
            </Typography>
            <ScoreLegendTable game={game} />
          </Grid>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog.Root>
  );
};
